import { LuSun, LuMoon } from "react-icons/lu";
import { useTheme } from "../../../contexts/ThemeContext";

export default function ThemeToggle({ expanded }: { expanded: boolean }) {
    const { theme, toggleTheme } = useTheme();
    const isDark = theme === "dark";

    return (
        <button
            onClick={toggleTheme}
            aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
            title={isDark ? "Switch to light mode" : "Switch to dark mode"}
            className={`flex items-center gap-3 w-full rounded-xl px-3 py-2.5 text-sm font-medium
                text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-white/5
                transition-colors ${expanded ? "justify-start" : "justify-center"}`}
        >
            <span className="text-lg shrink-0">{isDark ? <LuSun /> : <LuMoon />}</span>
            {expanded && <span className="truncate">{isDark ? "Light mode" : "Dark mode"}</span>}
        </button>
    );
}
